// extracted by mini-css-extract-plugin
export default {"containerAboutMe":"AboutMe_containerAboutMe__zD1b1","aboutTitle":"AboutMe_aboutTitle__TetrG","aboutContent":"AboutMe_aboutContent__bz7ci","aboutText":"AboutMe_aboutText__n3QuP"};